/**
 * @fileoverview Event system for dragging variable nodes from the canvas
 * into prompt editors.
 *
 * Uses a module-level singleton pattern (same as subjectDragEvent.ts).
 */

export interface VariableDragData {
  variableId: string
  name: string
  value: string
  color?: string
  /**
   * Initial cursor position (viewport-relative) at the moment the drag
   * activated. Lets a portal-rendered ghost render at the cursor on the
   * very first frame instead of waiting for the next `mousemove`.
   */
  initialClientX?: number
  initialClientY?: number
}

let draggedVariable: VariableDragData | null = null
const activeStateListeners = new Set<(isActive: boolean) => void>()

function notifyActiveState(isActive: boolean): void {
  activeStateListeners.forEach(listener => listener(isActive))
}

export function getVariableDrag(): VariableDragData | null {
  return draggedVariable
}

export function consumeVariableDrag(): VariableDragData | null {
  const data = draggedVariable
  draggedVariable = null
  if (data !== null) notifyActiveState(false)
  return data
}

export function hasVariableDrag(): boolean {
  return draggedVariable !== null
}

export function subscribeToVariableDragActive(listener: (isActive: boolean) => void): () => void {
  activeStateListeners.add(listener)
  return () => activeStateListeners.delete(listener)
}
